import React from 'react'
import Icon from 'components/Icon'
import useBreadcrumbs from 'use-react-router-breadcrumbs'

import { FormattedMessage, useIntl } from 'react-intl'
import { buildRoutes } from 'routes'
import { Link } from 'react-router-dom'
import messages from './messages'
import useUtmUrl from 'useUtmUrl'

export const Breadcrumbs = ({ showBackLink = false }) => {
  const { formatMessage } = useIntl()
  const routes = buildRoutes(formatMessage, { withBreadcrumbs: true })
  const breadcrumbs = useBreadcrumbs(routes)
  const backLink = useUtmUrl(breadcrumbs.slice(-2)[0].match.pathname)

  return (
    <nav className="w-full px-3 md:px-4 xl:px-1 text-xs font-medium mb-4 text-gray-400 truncate">
      <ol className="list-reset flex text-grey-dark overflow-x-hidden truncate">
        {showBackLink && (
          <React.Fragment>
            <li className="mx-2 text-primary font-medium leading-4 whitespace-no-wrap">
              <FormattedMessage
                {...messages.backText}
                values={{
                  link: (
                    <Link to={backLink} className="text-primary">
                      <Icon icon="angle-left" className="mr-2" />
                      <FormattedMessage {...messages.backLinkText} />
                    </Link>
                  ),
                }}
              />
            </li>

            <li className="leading-4">
              <span className="mx-2"> / </span>
            </li>
          </React.Fragment>
        )}

        {breadcrumbs.map(({ match, breadcrumb }, position) => (
          <li key={position} className="leading-4 whitespace-no-wrap">
            {position > 0 && <span className="mx-2 text-xs"> / </span>}
            <Link to={useUtmUrl(match.pathname)} className="hover:text-primary">
              {breadcrumb}
            </Link>
          </li>
        ))}
      </ol>
    </nav>
  )
}

export default Breadcrumbs
